import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Introducing Monitors",
  published_at: "2026-07-07",
  summary: "Keep tabs on the vendors, agencies, and opportunities you care about, and hear about every new award, amendment, and update the moment it happens.",
  tags: ["Platform", "AI"],
  draft: false
};
export const sections = [{
  id: "watch-what-matters",
  label: "Watch what matters"
}, {
  id: "delivered-where-you-work",
  label: "Delivered where you work"
}, {
  id: "set-it-up-in-seconds-with-ai",
  label: "Set it up in seconds with AI"
}];
function _createMdxContent(props) {
  const _components = {
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Your market moves whether you're watching or not. A competitor wins an award, an agency posts a new solicitation, an opportunity you've been chasing quietly gets amended. ", _jsx(_components.strong, {
        children: "Monitors"
      }), " keep an eye on all of it for you. Tell one what you care about, and the new awards, amendments, and updates show up in your inbox as they happen. No more refreshing SAM, digging through agency forecast pages, or finding out a week too late."]
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "b528e6e7-9d15-4217-9c47-30b55fc043de",
      aspectRatio: "1636 / 1080",
      className: "bg-white",
      frameClassName: "bg-white",
      edgeMaskClassName: "ring-2 ring-inset ring-white"
    }), "\n", _jsx(_components.h2, {
      id: "watch-what-matters",
      tabIndex: "-1",
      children: "Watch what matters"
    }), "\n", _jsx(_components.p, {
      children: "A single monitor can track any of four things:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vendors and competitors."
        }), " Awards, losses, and SAM profile changes for any company you're up against."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Agencies and offices."
        }), " Forecasts, new opportunities, and awards coming out of a buyer you sell to."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Opportunities."
        }), " Amendments, Q&A, and deadline changes on a solicitation you're already pursuing."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Web and keywords."
        }), " A search term or a specific web page, watched for any change."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "delivered-where-you-work",
      tabIndex: "-1",
      children: "Delivered where you work"
    }), "\n", _jsxs(_components.p, {
      children: ["Every match lands in your ", _jsx(_components.strong, {
        children: "Monitors inbox"
      }), ", and you can send it straight to ", _jsx(_components.strong, {
        children: "Slack"
      }), " or ", _jsx(_components.strong, {
        children: "email"
      }), " so the right people hear about it without logging in. Star what matters, archive the rest, and keep one clean feed of everything moving in your market."]
    }), "\n", _jsx(_components.h2, {
      id: "set-it-up-in-seconds-with-ai",
      tabIndex: "-1",
      children: "Set it up in seconds with AI"
    }), "\n", _jsxs(_components.p, {
      children: ["There isn't a single filter to configure. Just tell our AI what you want to track in plain English, like ", _jsx(_components.em, {
        children: "\"Watch Leidos and all DoD cybersecurity opportunities,\""
      }), " and it builds the right monitors with you, asking for what it needs as it goes."]
    }), "\n", _jsxs(_components.p, {
      children: ["Head to ", _jsx(_components.strong, {
        children: "Monitors"
      }), " in the sidebar and click ", _jsx(_components.strong, {
        children: "Set up my monitors with AI"
      }), " to get started."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
